import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "title-h4" }
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = {
  key: 0,
  class: "tab-pane fade in active show",
  id: "bilans",
  style: {"overflow-x":"auto"}
}
const _hoisted_9 = {
  key: 0,
  class: "table table-striped table-bordered"
}
const _hoisted_10 = { class: "thead-dark" }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_btn_edit = _resolveComponent("btn-edit")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isRequestBilan)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.bilans_list')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.bilansList?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.bilansList?.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                    _createElementVNode("thead", _hoisted_10, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.bilans.trainer')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.bilans.bilan_date')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.bilans.notes')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bilansList, (bilan) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `bilan-${bilan?.id}`
                        }, [
                          _createElementVNode("td", null, _toDisplayString(bilan?.trainer?.name ?? ' - '), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(bilan?.bilan_date)), 1),
                          _createElementVNode("td", null, _toDisplayString(bilan?.notes), 1),
                          _createElementVNode("td", null, [
                            (_ctx.hasPermission('delete_member_bilan'))
                              ? (_openBlock(), _createBlock(_component_btn_delete, {
                                  key: 0,
                                  onDelete: ($event: any) => (_ctx.deleteBilanItem(bilan?.id))
                                }, null, 8, ["onDelete"]))
                              : _createCommentVNode("", true),
                            (_ctx.hasPermission('edit_member_bilan'))
                              ? (_openBlock(), _createBlock(_component_btn_edit, {
                                  key: 1,
                                  onEdit: ($event: any) => (_ctx.emiEditBilan(bilan))
                                }, null, 8, ["onEdit"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_not_found, {
                text: _ctx.i18n.t('message.data_not_found.title'),
                icon: "warning"
              }, null, 8, ["text"])
            ]))
      ])
    ])
  ]))
}